// extracted by mini-css-extract-plugin
export default {"remainingReactionsButton":"gTjZugREFwJsCOo6JmtJ","active":"kzRWqk4obqHE25gFCV_7"};